import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addPermissionApi, addSingleSubadmin, changeSingleSubadminStatus, deleteSingleSubadmin, permissionModuleList, subadminList, subadminPermissionList, updatePermissionApi, updateSingleSubadmin } from "../apis/apiHandler";

export const subadmin = createAsyncThunk(
    "subadmin/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await subadminList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addSubadmin = createAsyncThunk(
    "subadmin/add",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await addSingleSubadmin(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateSubadmin = createAsyncThunk(
    "subadmin/update",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await updateSingleSubadmin(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteSubadmin = createAsyncThunk(
    "subadmin/delete",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteSingleSubadmin(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const changeSubadminStatus = createAsyncThunk(
    "subadmin/changeStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await changeSingleSubadminStatus(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const subadminPermission = createAsyncThunk(
    "subadmin/permission",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await subadminPermissionList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const permissionModule = createAsyncThunk(
    "subadmin/module_list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await permissionModuleList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addPermission = createAsyncThunk(
    "subadmin/add_permission",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await addPermissionApi(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updatePermission = createAsyncThunk(
    "subadmin/update_permission",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await updatePermissionApi(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    subadminList: [],
    addSubadminData: {},
    updateSubadminData: {},
    deleteSubadminData: {},
    changeSubadminStatusData: {},
    permissionModuleList: [],
    subadminPermissionList: [],
    addPermissionData: [],
    updatePermissionData: [],
    error: null,
    success: false,
};

const suadminSlice = createSlice({
    name: "subadmin",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(subadmin.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(subadmin.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.subadminList = payload;
                state.success = true;
            })
            .addCase(subadmin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addSubadmin.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addSubadmin.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addSubadminData = payload;
                state.success = true;
            })
            .addCase(addSubadmin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(updateSubadmin.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(updateSubadmin.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.updateSubadminData = payload;
                state.success = true;
            })
            .addCase(updateSubadmin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(deleteSubadmin.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(deleteSubadmin.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.deleteSubadminData = payload;
                state.success = true;
            })
            .addCase(deleteSubadmin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(changeSubadminStatus.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(changeSubadminStatus.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.changeSubadminStatusData = payload;
                state.success = true;
            })
            .addCase(changeSubadminStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(subadminPermission.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(subadminPermission.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.subadminPermissionList = payload;
                state.success = true;
            })
            .addCase(subadminPermission.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(permissionModule.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(permissionModule.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.permissionModuleList = payload;
                state.success = true;
            })
            .addCase(permissionModule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addPermission.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addPermission.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addPermissionData = payload;
                state.success = true;
            })
            .addCase(addPermission.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(updatePermission.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(updatePermission.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.updatePermissionData = payload;
                state.success = true;
            })
            .addCase(updatePermission.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })

    },
});

export default suadminSlice.reducer;
